import { useEffect } from 'react'
import { getTemplateById } from '@user/store/agreements'
import { ENTITY_TYPES, useAppDispatch } from '@sales-center/common'

export function useLoadTemplate(
  id: number | '' | undefined,
  proposalEntityId: number,
  proposalEntityType: ENTITY_TYPES,
  dsbServiceIds?: number[],
) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (id) {
      dispatch(
        getTemplateById({
          id,
          proposalEntityId,
          proposalEntityType,
          dsbServiceIds,
        }),
      )
    }
  }, [dispatch, dsbServiceIds, id, proposalEntityId, proposalEntityType])
}
